import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import SettingsIcon from '@material-ui/icons/Settings';
import { ChevronLeft, ChevronRight, PermMedia, LocalOffer, ShoppingCart, FormatListBulleted, Group, ExitToApp, CalendarTodaySharp } from '@material-ui/icons'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
const drawerWidth = 300;
const  rolesArticulos= [1, 2];
const  rolesPedidos= [1, 4];
const  rolesRubros= [1, 2];
const  rolesUsuarios= [1];





const styles = theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }
});


class MyDrawer extends React.Component {

    render() {

        const { classes, theme } = this.props;
   
        return (
        <Drawer
            variant={this.props.isPermanent ? "permanent" : 'drawerNoPermanent'}
            className={`${this.props.isPermanent ? 'drawerPermanent' : ''} ${classNames(classes.drawer, {
              [classes.drawerOpen]: this.props.drawerOpen,
              [classes.drawerClose]: !this.props.drawerOpen,
            })}`}
            classes={{
              paper: classNames({
                [classes.drawerOpen]: this.props.drawerOpen,
                [classes.drawerClose]: !this.props.drawerOpen,
              }),
            }}
            open={this.props.drawerOpen}
        >
            <div className={classNames(classes.toolbar, 'drawerToolbarHeader')}>
              
              {/* logo */}
              <div className='logoContainer center' noWrap>
                <Link to='/'>
                  <img alt="grey logo" src={require('../../images/logoDrawer.png')}  />
                </Link>
              </div>
              
              <IconButton onClick={this.props.handleDrawerClose}>
                {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
              </IconButton>
            </div>
            <Divider />
            <List className='menuItem'>
              
            {/* this.props.usuario && this.props.instalacion !== undefined && rolesArticulos.find(x=>x === this.props.usuario.idRol)>0 && 
                            
              <Link to={'/Catalogo/'+ this.props.instalacion.id} onClick={this.props.handleDrawerClose}>
                  <ListItem button key='catalogo'>
                      <ListItemIcon><PermMedia /></ListItemIcon>
                          <ListItemText primary='Catálogo' />
          
                          </ListItem>
                        </Link>
          */}

            {/*
              <Link to={'/Articulo'}>
                <ListItem button key='articulos' onClick={this.props.handleDrawerClose}>
                    <ListItemIcon><LocalOffer /></ListItemIcon>
                    <ListItemText primary='Artículos' />
                </ListItem>
            </Link>
        */}
            
              
              { this.props.usuario && rolesPedidos.find(x=>x === this.props.usuario.idRol)>0 && 
              <Link to={'/Pedidos'} >
              <ListItem button key='pedidos' onClick={this.props.handleDrawerClose}>
                  <ListItemIcon><ShoppingCart /></ListItemIcon>
                  <ListItemText primary='Pedidos' />
              </ListItem>
              </Link>}

              {/* this.props.usuario && rolesPedidos.find(x=>x === this.props.usuario.idRol)>0 && 
              <Link to={'/Calendario'} >
              <ListItem button key='calendario_pedidos' onClick={this.props.handleDrawerClose}>
                  <ListItemIcon><CalendarTodaySharp /></ListItemIcon>
                  <ListItemText primary='Calendario de pedidos' />
              </ListItem>
              </Link>*/}


              {/*
              <Link to={'/Promociones'} onClick={this.props.handleDrawerClose}>
              <ListItem button key='promociones'>
                  <ListItemIcon><AttachMoney /></ListItemIcon>
                  <ListItemText primary='Promociones' />
              </ListItem>
              </Link>
              */}

              {/* DESCOMENTAR PARA VER ESTA FUNCIONALIDAD <ListItem button key='reportes'>
                  <ListItemIcon><InsertDriveFile /></ListItemIcon>
                  <ListItemText primary='Reportes' />
              </ListItem>*/}
              
              {/* this.props.usuario && rolesRubros.find(x=>x === this.props.usuario.idRol)>0 && 
              <Link to={'/Rubros'} onClick={this.props.handleDrawerClose}>
                <ListItem button key='rubros'>
                    <ListItemIcon><FormatListBulleted /></ListItemIcon>
                    <ListItemText primary='Rubros' />
                </ListItem>
            </Link>*/}

              {/* this.props.usuario && rolesRubros.find(x=>x === this.props.usuario.idRol)>0 && 
              <Link to={'/Picking'} onClick={this.props.handleDrawerClose}>
                <ListItem button key='picking'>
                    <ListItemIcon><ShoppingBasketIcon /></ListItemIcon>
                    <ListItemText primary='Picking' />
                </ListItem>
          </Link>*/}

              { this.props.usuario && rolesRubros.find(x=>x === this.props.usuario.idRol)>0 && 
              <Link to={'/Contenido'} onClick={this.props.handleDrawerClose}>
                <ListItem button key='contenido'>
                    <ListItemIcon><InsertDriveFileIcon /></ListItemIcon>
                    <ListItemText primary='Contenido' />
                </ListItem>
              </Link>}

              { this.props.usuario && rolesRubros.find(x=>x === this.props.usuario.idRol)>0 && 
              <Link to={'/Configuracion'} onClick={this.props.handleDrawerClose}>
                <ListItem button key='Configuracion'>
                    <ListItemIcon><SettingsIcon /></ListItemIcon>
                    <ListItemText primary='Configuración' />
                </ListItem>
              </Link>}

              {/* DESCOMENTAR PARA VER ESTA FUNCIONALIDAD <ListItem button key='configuracion' onClick={this.props.handleDrawerClose}>
                  <ListItemIcon><Settings /></ListItemIcon>
                  <ListItemText primary='Configuración' />
              </ListItem>*/}
              
              { this.props.usuario && rolesUsuarios.find(x=>x === this.props.usuario.idRol)>0 && 
                <Link to={'/Usuarios'}>
                <ListItem button key='usuarios' onClick={this.props.handleDrawerClose}>
                    <ListItemIcon><Group /></ListItemIcon>
                    <ListItemText primary='Usuarios' />
                </ListItem>
              </Link>}

              <ListItem 
                button key='cerrarSesion'
                onClick={() => this.props.handleCerrarSession()}
                >
                  <ListItemIcon><ExitToApp /></ListItemIcon>
                  <ListItemText primary='Cerrar sesión' />
              </ListItem>
            </List>
        </Drawer>
        )
    }
}

MyDrawer.propTypes = {
    drawerOpen: PropTypes.bool.isRequired,
    
    handleDrawerClose: PropTypes.func.isRequired,
    handleCerrarSession: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    usuario:PropTypes.object.isRequired,
    isPermanent: PropTypes.bool.isRequired,

};


  
export default withStyles(styles, { withTheme: true })(MyDrawer);